import * as React from "react";

import "./user-created-template-modal.scss";

import {bindInput}         from "@Common/react/bind-input";
import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {Load2}             from "@Common/react/load2";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {Responsive}        from "@Common/ui-components/responsive";
import {SearchableSelect}  from "@Common/ui-components/searchable-select/searchable-select";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {ModalLayout}       from "../../../common/modal-layout/modal-layout";

export const UserCreatedTemplateModal = ({key, onClick, onClose, next: rootNext}) => cs(
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["modal", ({responsive}, next) => <>
        {key || key===0 ? (
            <ModalService3 {...{
                xdQaName: "User Created Template Modal",
                width: responsive.lt("mobile") ? 360 : "fit-content",
                xToClose: false,
                onPassiveClose: async () => {
                    return false;
                },
                onClose,
                next,
                rootNext,
            }}/>
        ) : (
            rootNext()
        )}
    </>],
    consumeContext("apis"),
    ["folders", ({apis}, next) => Load2({
        fetch: () => apis.next.userCreated.getFolders( 0, 'notArchive' ),
        next,
    })],
    ["template", ({apis}, next) => Load2({
        fetch: () => key ? apis.next.userCreated.getTemplate(key) : { idCategory: null, active: true },
        next,
    })],
    ["uploading", (_, next) => UseState({next})],
    ({modal, template, uploading}, next) => ModalLayout({
        title: "Template Information",
        content: next(),
        buttons: [
            {
                label: "Cancel",
                onClick: () => {
                    modal.close();
                },
            },
            {
                label: uploading.value ? "Saving" : "Save",
                disabled: uploading.value || !template.value?.name,
                spinner: !!uploading.value,
                primary: true,
                onClick: async () => {
                    uploading.onChange(true);
                    let close = await onClick(template);
                    if ( close ) {
                        modal.close();
                    }
                    uploading.onChange(false);
                },
            },
        ],
    }),
    ({folders, template}) => (template.loading || folders.loading ? (
            <div className="user-created-template-modal-3ct">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : (
            <div className="user-created-template-modal-3ct">
                <div className="input-card">
                    <div className="label">Template Name <span style={{color: "red"}}> *</span></div>
                    <input {...{
                        className: "value",
                        maxLength: 64,
                        "xd-qa-type": "textbox",
                        "xd-qa-name": "Enter a Template Name",
                        ...bindInput(scopedState(template, ["name"]))
                    }}/>
                    <div className="label">Select a Folder</div>
                    {SearchableSelect({
                        getLabel: (i) => i.label,
                        value: scopedState(template, ['idCategory']).value,
                        isSelected: (i) => i.value === scopedState(template, ['idCategory']).value,
                        onSelect: (i) => {
                            scopedState(template, ['idCategory']).onChange(i?.value);
                        },
                        placeholder: "Select...",
                        "xd-qa-type":"dropdown",
                        xdQaName: "Select a Folder",
                        className: "select",
                        list: getFolders(folders.value)
                    })}
                    <div className="check-line">
                        <div>Active</div>
                        {SliderCheckbox({
                            ...scopedState(template, ['active']),
                            xdQaName: "Active",
                        })}
                    </div>
                </div>
            </div>
        )
    )
);

const getFolders = (sourceFolders) => {
    let folders = [];
    sourceFolders.forEach((folder) => {
        let idPrimary = null;
        if(folder?.idPrimary){
            idPrimary = folder.idPrimary;
        }
        folders.push({label: folder?.name, value: idPrimary});
    });
    return folders;
};